import Vue from 'vue';
import telGroupItem from './telGroupItem'

export default class telGroup{
    constructor(options) {
        this.cache(options)
        this.init()
    }
    cache(options) {
        this.settings = Vue.observable({
            ...this.defaults,
            ...options
        });
        this.value = options.value || []
        this.complexSorte()
        //this.sortById()
        return this
    }
    get defaults() {
        return {
            key: new Date().getTime(),
            name: 'Новая группа',
            icon: '#icon-offline',
        }
    }
    get name() {
        return this.settings.name
    }
    get color() {
        return this.settings.color
    }
    get value() {
        return this.settings.value
    }

    get icon() {
        return this.settings.icon
    }
    get status() {
        return this.settings.status
    }

    get id() {
        return this.settings.id
    }

    set value(value) {
        const nList = value.map(item => value instanceof telGroupItem ? item : new telGroupItem(item))
        this.settings.value = nList
    }
    get isValue() {
        return this.value.length > 0
    }
    init() {
        this.sortByAgentId()
        return this
    }
    getUserById(id) {
        return this.value.find(item => item.id === id)
    }

    removeItemById(id) {
        this.value = this.value.filter(item => item.id !== id)
    }

    addItem(item) {
        this.value.push(item)
        this.sortByAgentId()
    }

    setItem(item) {
        //this.value.push(item)
    }
    
    sortById() {
        this.value.sort((a, b) => a.id - b.id)
    }

    sort() {
        this.complexSorte()
    }
    
    complexSorte() {
        const groups = {};
        const noStatus = [];

        // 1) Группируем за один проход
        this.value.forEach(item => {
            const s = (item.status_value || "").trim();

            if (!s) {
                noStatus.push(item);
                return;
            }

            if (!groups[s]) groups[s] = [];
            groups[s].push(item);
        });

        // 2) Сортируем элементы без статуса
        noStatus.sort((a, b) => a.agent_id - b.agent_id);

        const sortList = {
            online: 1,
            in_call: 1,   // одинаковый приоритет → порядок изначальный
            offline: 2,
            away: 3,
            no_ping: 4,
            not_disturb: 5
        };

        // 3) Получаем список статусов и сортируем по sortList
        const statuses = Object.keys(groups).sort((a, b) => {
            return sortList[a] - sortList[b];
        });

        // 4) Собираем итог
        const result = [];

        statuses.forEach(status => {

            // online → сортируем по agent_id
            if (status === "online") {
                groups[status].sort((a, b) => a.agent_id - b.agent_id);
            }

            // in_call → НЕ сортировать (оставить как есть!)

            // остальные → сортируем по agent_id
            if (status !== "in_call" && status !== "online") {
                groups[status].sort((a, b) => a.agent_id - b.agent_id);
            }

            result.push(...groups[status]);
        });

        // 5) Добавляем без статуса
        result.push(...noStatus);

        this.value = result;
    }


    getMassbyStatus() {
        const ret = []
        this.value.forEach(item => {
            if(!ret[item.status]) ret[item.status] = []
            ret[item.status].push(item)
        })
        return 
    }

    

    sortByAgentId() {
        this.value.sort((a, b) => a.agent_id - b.agent_id)
    }
}